// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import {ms} from '/util/date.js';
import {APP_STATUSES, BILLING_TYPES, BILL_KINDS, AUTH_ROUTES,
    NOTIF_TARGET_KIND, PAYOUT_EVENTS, BRD_PRODUCT_KIND,
    BNDL_OFFER_KIND} from './shared/constants.js';

if (!window.embedded_data?.cp_url)
    throw new Error('missing "cp_url" in embedded_data');
export const CP_URL = window.embedded_data.cp_url;
if (!window.embedded_data?.url_prefix)
    throw new Error('missing "url_prefix" in embedded_data');
export const URL_PREFIX = window.embedded_data.url_prefix;
export const VERSION = window.embedded_data?.ver;
export const PEER_KIND = {
    [BILLING_TYPES.PER_IP]: 'IP',
    [BILLING_TYPES.PER_DEVICE]: 'device',
    [BILLING_TYPES.PER_INSTALL]: 'install',
    [BILLING_TYPES.PER_OPTIN]: 'opt-in',
};
export const BILLING_TITLES = {
    [BILLING_TYPES.EMPTY]: `Deleted`,
    [BILLING_TYPES.PER_IP]: `Per ${PEER_KIND[BILLING_TYPES.PER_IP]}`,
    [BILLING_TYPES.PER_DEVICE]:
        `Per ${PEER_KIND[BILLING_TYPES.PER_DEVICE]}`,
    [BILLING_TYPES.PER_INSTALL]:
        `Per ${PEER_KIND[BILLING_TYPES.PER_INSTALL]}`,
    [BILLING_TYPES.PER_OPTIN]:
        `Per ${PEER_KIND[BILLING_TYPES.PER_OPTIN]}`,
};
export const APP_STATUS_SCHEME = {
    id: null,
    leafs: [{
        id: APP_STATUSES.IMPLEMENTATION,
        leafs: [{
            id: APP_STATUSES.PENDING_REVIEW,
            leafs: [{
                id: APP_STATUSES.APPROVED,
                leafs: [{
                    id: APP_STATUSES.LIVE,
                }],
            }],
        }],
    },
    {id: APP_STATUSES.DISABLED},
]};
export const LOCAL_STORAGE_KEYS = {
    show_trends_partners: 'sdk_cp.show_trends_partners',
    show_disabled_partners: 'sdk_cp.show_disabled_partners',
    show_suspended_partners: 'sdk_cp.show_suspended_partners',
    show_trends_apps: 'sdk_cp.show_trends_apps',
    review_mode_apps: 'sdk_cp.review_mode_apps',
    show_disabled_apps: 'sdk_cp.show_disabled_apps',
    show_removed_apps: 'sdk_cp.show_removed_apps',
    status_filter: 'sdk_cp.status_filter',
    apps_os_filter: 'sdk_cp.apps_os_filter',
    sort_col_apps: 'sdk_cp.sort_col_apps',
    sort_col_reverse_apps: 'sdk_cp.sort_col_reverse_apps',
    utm_map: 'sdk_cp.utm_map',
    origin_url: 'sdk_cp.origin_url',
    commission_report_show_errors: 'sdk_cp.commission_report_show_errors',
    signup_promo: 'sdk_cp.signup_promo',
    signup_ref: 'sdk_cp.signup_ref',
};
export const TF_SECTION_TITLE = 'Apple TestFlight Invitation';
export const TF_TITLE = 'Invite link';
export const ROKU_BETA_TITLE = 'Roku beta channel invite';
export const BILL_KIND_NAME = {
    [BILL_KINDS.ONE_TIME]: 'One-time payment',
    [BILL_KINDS.MONTHLY]: 'Monthly bill',
    [BILL_KINDS.REFERRAL]: 'Referral monthly bill',
};
export const CASHOUT_NAME = 'Funds transfer';
export const PRIVACY_POLICY_LINK = 'https://bright-sdk.com/privacy-policy';
export const PARTNER_PROGRAM_LINK = 'https://media.bright-sdk.com/2025/04/Partner-Program-Terms-Conditions.pdf';
export const BVPN_BUNDLE_GUIDE_LINK = 'https://help.bright-sdk.com/hc/en-us/articles/27121754139153-Bright-VPN-Bundle-Integration-Guide';
export const BVPN_BUNDLE_RESOURCES_LINK = 'https://drive.google.com/drive/folders/1et9wqt4uWKelzk7ihCxj4pfCXUfUggY9';
export const IMPL_CHECK_LINK = 'https://help.bright-sdk.com/hc/en-us/articles/19944063423121-How-can-I-check-that-my-implementation-works-well-';
export const USERS_MANAGE_LINK = 'https://help.bright-sdk.com/hc/en-us/articles/19623147079313-How-can-I-add-remove-more-users-to-my-Bright-SDK-account';
export const VIDEO_INTRO_LINK = 'https://www.youtube.com/watch?v=1-Lbgd4BYHI';
export const TF_VIDEO_LINK =
    'https://drive.google.com/file/d/18cXRcKm12sixiRAOna9669ebvSCcJolU/view';
export const BILLING_FLOW_FAQ = 'https://help.bright-sdk.com/hc/en-us/articles/20009767859857-What-is-the-process-to-get-the-monthly-payment-';
export const API_FAQ = 'https://help.bright-sdk.com/hc/en-us/articles/22348849397521-Does-Bright-SDK-dashboard-offer-reports-API';
export const AMAZON_GLOSSARY_PN =
    'https://developer.amazon.com/docs/app-submission/glossary.html#package_name';
export const AMAZON_SUBMISSION_GUIDE =
    'https://developer.amazon.com/docs/app-submission/upload-app-file.html#upload-your-app-file';
const to_cp_url = url=>`${CP_URL}${url}`;
export const ROUTES = {
    ...Object.entries(AUTH_ROUTES).reduce((acc, entry)=>({
        ...acc,
        [entry[0]]: to_cp_url(entry[1]),
    }), {}),
    DASHBOARD: to_cp_url('/dashboard'),
    APPS: to_cp_url('/apps'),
    APPS_LEGACY: to_cp_url('/reports/apps_legacy'),
    REVIEWS: to_cp_url('/reviews'),
    PARTNERS: to_cp_url('/partners'),
    USERS: to_cp_url('/users'),
    REPORTS: to_cp_url('/reports'),
    REPORTS_REVENUE: to_cp_url('/reports/revenue'),
    REPORTS_FUNNELS: to_cp_url('/reports/funnels'),
    REPORTS_RETENTION: to_cp_url('/reports/retention'),
    REPORTS_PEERS: to_cp_url('/reports/peer_stats'),
    REPORTS_COMMISSION: to_cp_url('/reports/commission'),
    SUMMARY_METRICS: to_cp_url('/reports/metrics_summary'),
    REPORTS_QUALIFIED: to_cp_url('/reports/qualified'),
    CHECKLISTS: to_cp_url('/checklists'),
    CHECKLISTS_LIST: to_cp_url('/checklists/all'),
    CHECKLISTS_MEDIA: to_cp_url('/checklists/media'),
    BILLING: to_cp_url('/billing'),
    BILLING_INVOICES: to_cp_url('/billing/invoices'),
    BILLING_HISTORY: to_cp_url('/billing/history'),
    BILLING_MANAGE: to_cp_url('/billing/management'),
    DOCS: to_cp_url('/docs'),
    DOCS_SDK: to_cp_url('/docs/sdk'),
    DOCS_BUNDLES: to_cp_url('/docs/bundles'),
    TOOLS_COMPONENTS: to_cp_url('/tools/components'),
    SETTINGS_PROFILE: to_cp_url('/settings/company_profile'),
    SETTINGS_USER_PROFILE: to_cp_url('/settings/profile'),
    SETTINGS_PASS: to_cp_url('/settings/change_password'),
    TIERS: to_cp_url('/tiers'),
    NOTIFS: to_cp_url('/notifications'),
    BUNDLES: to_cp_url('/bundles'),
    REFERRALS: to_cp_url('/referrals'),
};
export const CACHE_LIFETIME = 5*ms.MIN;
export const NEW_TAB_ATTRS = {
    target: '_blank',
    rel: 'noreferrer noopener'
};
export const DASHBOARD_CRUMB = {
    title: 'Dashboard',
    icon: 'ico_dashboard',
    path: ROUTES.DASHBOARD,
};
export const APPS_CRUMB = {
    title: 'Apps',
    icon: 'ico_apps',
    path: ROUTES.APPS,
};
export const REVIEWS_CRUMB = {
    title: 'Reviews',
    icon: 'ico_thumb_up',
    path: ROUTES.REVIEWS,
};
export const USERS_CRUMB = {
    title: 'Users',
    icon: 'ico_user',
};
export const PARTNERS_CRUMB = {
    title: 'Partners',
    icon: 'ico_group',
    path: ROUTES.PARTNERS,
};
export const BILLING_CRUMB = {
    title: 'Billing',
    icon: 'ico_billing',
    path: ROUTES.BILLING,
};
export const TIERS_CRUMB = {
    title: 'Partner Program',
    icon: 'ico_medal',
    path: ROUTES.TIERS,
};
export const DOCS_CRUMB = {
    title: 'Documentation',
    icon: 'ico_code_file',
    path: ROUTES.DOCS,
};
export const BUNDLES_CRUMB = {
    title: 'Monetized Bundles',
    icon: 'ico_box',
    path: ROUTES.BUNDLES,
};
export const CHECKLISTS_CRUMB = {
    title: 'Checklists',
    icon: 'ico_checklist',
    path: ROUTES.CHECKLISTS,
};
export const REPORTS_CRUMB = {
    title: 'Reports',
    icon: 'ico_chart',
    path: ROUTES.REPORTS,
};
export const SETTINGS_CRUMB = {
    title: 'Settings',
    icon: 'ico_settings',
    path: ROUTES.SETTINGS_PROFILE,
};
export const SUMMARY_CRUMB = {
    title: 'Summary Metrics',
    icon: 'ico_chart',
    path: ROUTES.SUMMARY_METRICS,
};
export const NOTIFS_CRUMB = {
    title: 'Notifications',
    icon: 'ico_mail',
    path: ROUTES.NOTIFS,
};
export const REFERRALS_CRUMB = {
    title: 'Referral Program',
    icon: 'ico_referrals',
    path: ROUTES.REFERRALS,
};
export const EXAMPLE_APP_DOWNLOAD_URL = 'https://example.io/apps/app_name/dist/xxxx.zip';
export const TARGET_KIND_LABELS = {
    [NOTIF_TARGET_KIND.ROOTS]: 'All root users',
    [NOTIF_TARGET_KIND.ALL]: 'All users',
    [NOTIF_TARGET_KIND.OS]: 'Specific OS holders',
    [NOTIF_TARGET_KIND.PARTNER]: 'Specific partner',
    [NOTIF_TARGET_KIND.USER]: 'Specific user',
    [NOTIF_TARGET_KIND.EMAIL]: 'Specific email',
};
const UUID_COLOR_SCHEME = [134, 190, 237];
export const CHART_COLOR_SCHEMES = {
    earnings: [28, 176, 124],
    ips: [61, 127, 252],
    bw: [76, 126, 204],
    devices: UUID_COLOR_SCHEME,
    devices_qualified: UUID_COLOR_SCHEME,
    installs: [126, 33, 206],
    optins: [145, 191, 113],
};
export const CHART_TITLES = {
    earnings: 'Revenue',
    bw: 'Bandwidth',
    ips: 'Daily Active IPs',
    devices: 'Daily Active Devices',
    devices_qualified: 'Daily Active Devices',
    installs: 'Installations',
    optins: 'Opt-ins',
};
const OPS_LOCK = {
    ico: 'ico_lock',
    value: 'Transactions editing, upfront payments adding,\n'+
      ' and bonuses adding are locked for the partner in the month',
};
const ATTACH_OK = {
    ico: 'ico_unlock',
    value: 'Partner is able to attach an invoice file',
};
const ATTACH_NOT_OK = {
    ico: 'ico_lock',
    value: 'Partner is NOT able to attach an invoice file',
};
const REVERT_OK = {
    ico: 'ico_unlock',
    value: 'An approval revert is possible',
};
export const PAYOUT_STATUSES = [
    PAYOUT_EVENTS.APPROVED,
    PAYOUT_EVENTS.INVOICE_ATTACHED,
    PAYOUT_EVENTS.VERIFIED,
    PAYOUT_EVENTS.PAID,
];
export const PAYOUT_STATUS_META = {
    [PAYOUT_EVENTS.CREATED]: {
        field: 'num',
        header: 'Created, ready to be reviewed',
        bullets: [],
    },
    [PAYOUT_EVENTS.REVERTED]: {
        field: 'num',
        header: 'Reverted, ready to be reviewed',
        bullets: [],
    },
    [PAYOUT_EVENTS.APPROVED]: {
        field: 'approved',
        header: 'Approved and sent to a partner',
        bullets: [
            {
                ico: 'ico_invoice',
                value: 'An invoice template has been sent to the partner',
            },
            {
                ico: 'ico_clock',
                value: 'Waiting for invoice file to be attached',
            },
            ATTACH_OK,
            OPS_LOCK,
            REVERT_OK,
        ],
    },
    [PAYOUT_EVENTS.INVOICE_ATTACHED]: {
        field: 'invoice_attached',
        header: 'Invoice file submitted',
        bullets: [
            {
                ico: 'ico_clock',
                value: 'Waiting for invoice verification',
            },
            ATTACH_OK,
            OPS_LOCK,
            REVERT_OK,
        ],
    },
    [PAYOUT_EVENTS.VERIFIED]: {
        field: 'payable',
        header: 'Verified and ready to be paid',
        bullets: [
            {
                ico: 'ico_clock',
                value: 'Waiting for money transfer',
            },
            ATTACH_NOT_OK,
            OPS_LOCK,
            REVERT_OK,
        ],
    },
    [PAYOUT_EVENTS.PAID]: {
        field: 'paid',
        header: 'Paid, money transferred to partner\'s account',
        bullets: [
            {
                ico: 'ico_check',
                value: 'Completed',
            },
            ATTACH_NOT_OK,
            OPS_LOCK,
            {
                ico: 'ico_lock',
                value: 'Approval revert is NOT possible',
            },
        ],
    },
};
export const BRD_PRODUCT_META = {
    [BRD_PRODUCT_KIND.VPN]: {
        name: 'Bright VPN',
        guide_url: BVPN_BUNDLE_GUIDE_LINK,
        resources: BVPN_BUNDLE_RESOURCES_LINK,
        links: [{
            name: 'Implementation Guide',
            url: BVPN_BUNDLE_GUIDE_LINK,
        }, {
            name: 'Assets (Google Drive)',
            url: BVPN_BUNDLE_RESOURCES_LINK,
        }],
        description: `BrightVPN is a free, user-friendly VPN
          designed to protect users' online privacy by hiding their
          IP address and encrypting internet activity.`,
        ico: 'ico_bvpn',
    },
};
export const BUNDLES_META = {
    [BRD_PRODUCT_KIND.VPN]: {
        win: {
            offer_description: {
                [BNDL_OFFER_KIND.BANNER]: `Present a BrightVPN install offer
                  (banner/pop up etc) within your app`,
                [BNDL_OFFER_KIND.INSTALL]: `Earn revenue from users who
                  successfully installed your product by presenting
                  a BrightVPN install offer on your product's successful
                  installation page`,
                [BNDL_OFFER_KIND.UNINSTALL]: `Earn revenue from users who
                  choose to uninstall your product by presenting
                  a BrightVPN install offer on your product's uninstall page`,
                [BNDL_OFFER_KIND.WIZARD]: `Add a screen to your install
                  wizard offering users to install BrightVPN`,
                [BNDL_OFFER_KIND.G_AD]: `Create an ad campaign offering
                  to install BrightVPN - get paid for every install
                  you bring!`,
                [BNDL_OFFER_KIND.PREINSTALLED]: `Install BrightVPN on products
                  you distribute (refurbished products,
                  device manufacturers, OEM etc)`,
            },
        }
    }
};
export const REACT_ROOT_ID = 'root';
export const REF_LINK = 'https://bright-sdk.com/i/';
export const REF_AGREEMENT_LINK = 'https://bright-sdk.com/referral-agreement';
export const REF_INFO_LINK = 'https://bright-sdk.com/referral';
